import * as RadixPopover from '@radix-ui/react-popover';
import classNames from 'classnames';
import { memo } from 'react';

import { XIcon as CloseIcon } from '@air/design-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

export type PopoverCloseButton = RadixPopover.PopoverCloseProps;

export const PopoverCloseButton = memo(({ className, ...restOfProps }: PopoverCloseButton) => {
  return (
    <RadixPopover.Close
      className={classNames(
        'flex h-6 w-6 items-center justify-center rounded-4 border-0 bg-transparent ads:text-primary text-gray-12 outline-none hover:ads:bg-hover-subtle hover:bg-pigeon-4 focus-visible:ads:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 active:ads:bg-hover-subtle active:bg-gray-4',
        className,
      )}
      {...restOfProps}
    >
      <VisuallyHidden>Close popover</VisuallyHidden>
      <CloseIcon size="sm" />
    </RadixPopover.Close>
  );
});

PopoverCloseButton.displayName = 'PopoverCloseButton';
